import { useAuth } from '../../hooks/useAuth'
import { useNavigate, useLocation, Link } from 'react-router-dom'

const NAV_LINKS = [
  { label: 'Dashboard', path: '/dashboard' },
  { label: 'Prospects', path: '/' },
  { label: 'Import',    path: '/import' },
  { label: 'Campaigns', path: '/campaigns' },
  { label: '🔥 Warm', path: '/warm' },
  { label: 'Mail Agents', path: '/mail-agents' },
]

export default function Navbar() {
  const { logout } = useAuth()
  const navigate = useNavigate()
  const location = useLocation()

  const handleLogout = () => {
    logout()
    navigate('/login')
  }

  return (
    <nav style={styles.nav}>
      <div style={styles.left}>
        <div style={styles.logo}>PE</div>
        <span style={styles.name}>Prospecting Engine</span>
        <div style={styles.links}>
          {NAV_LINKS.map(({ label, path }) => (
            <Link
              key={path}
              to={path}
              style={{
                ...styles.link,
                ...(location.pathname === path ? styles.linkActive : {}),
              }}
            >
              {label}
            </Link>
          ))}
        </div>
      </div>
      <button onClick={handleLogout} style={styles.logoutBtn}>
        Sign out
      </button>
    </nav>
  )
}

const styles = {
  nav: {
    height: 56,
    borderBottom: '0.5px solid #e0dfd8',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 1.5rem',
    background: '#fff',
    position: 'sticky',
    top: 0,
    zIndex: 50,
  },
  left: { display: 'flex', alignItems: 'center', gap: 16 },
  logo: {
    width: 32, height: 32, borderRadius: 8,
    background: '#1a1a1a', color: '#fff',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontSize: 12, fontWeight: 600, letterSpacing: 1,
  },
  name: { fontSize: 15, fontWeight: 500, color: '#1a1a1a' },
  links: { display: 'flex', gap: 4, marginLeft: 8 },
  link: {
    fontSize: 13, color: '#666', textDecoration: 'none',
    padding: '5px 10px', borderRadius: 6,
  },
  linkActive: {
    color: '#1a1a1a', fontWeight: 500,
    background: '#f5f5f3',
  },
  logoutBtn: {
    background: 'none', border: '0.5px solid #ccc',
    borderRadius: 8, padding: '6px 14px',
    fontSize: 13, cursor: 'pointer', color: '#444',
  },
}